module.exports = __webpack_public_path__ + "img/caret-square-up.1982150c.svg";